import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType, SpecyficType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { BedsideTableBodyToSimpleSapElementMapper } from './bedsideTableBodyToSimpleSapElementMapper';
import { BedsideTableLegsToSimpleSapElementMapper } from './bedsideTableLegsToSimpleSapElementMapper';
import { HandleToSimpleSapElementMapper } from '../handleToSimpleSapElementMapper';
import { BedsideTableDrawerToSimpleSapElementMapper } from './bedsideTableDrawerToSimpleSapElementMapper';
import { BedsideTableFrontToSimpleSapElementMapper } from './bedsideTableFrontToSimpleSapElementMapper';

export class BedsideTableToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private body = new BedsideTableBodyToSimpleSapElementMapper();
    private front = new BedsideTableFrontToSimpleSapElementMapper();
    private drawer = new BedsideTableDrawerToSimpleSapElementMapper();
    private legs = new BedsideTableLegsToSimpleSapElementMapper();
    private handle = new HandleToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.body;
        }
        if (element.type === ElementType.FRONT) {
            return this.front;
        }
        if (element.specyficType === SpecyficType.DRAWER) {
            return this.drawer;
        }
        if (element.type === ElementType.LEGS) {
            return this.legs;
        }
        if (element.type === ElementType.HANDLE) {
            return this.handle;
        }
        return this.null;
    }
}